// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.ModalCC_boxModal__Hj\\+iU {
  animation: ModalCC_init__KtfK6 0.3s;
  transition: 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 5px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_exit__l0hRt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_exit__l0hRt .ModalCC_exitIcon__4Z15a {
  transition: 0.3s;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_exit__l0hRt .ModalCC_exitIcon__4Z15a:hover {
  transition: 0.2s;
  scale: 1.1;
  cursor: pointer;
  filter: brightness(1.6);
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_titleModal__yGma7 {
  display: flex;
  justify-items: center;
  align-items: center;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_titleModal__yGma7 p {
  font-size: 1.3rem;
  margin: 0;
  margin-left: 5px;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_balance__zNKb2 p {
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 1.5rem;
  font-weight: 300;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_loader__hlQ99 {
  transition: 0.5s;
  min-height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_search__tDNCY {
  animation: ModalCC_init3__Lyufy 0.3s both 1s;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_tableContainer__5DhEW {
  box-shadow: 0 5px 10px -3px rgba(0, 0, 0, 0.211);
  animation: ModalCC_init2__t6NoA 0.3s both 0.3s;
  max-height: 100%;
  border-radius: 5px;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_noresult__8oow6 {
  animation: ModalCC_init3__Lyufy 0.3s both 0.3s;
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  font-weight: 300;
}

.ModalCC_boxModal__Hj\\+iU .ModalCC_pagination__3fkba {
  animation: ModalCC_init3__Lyufy 0.3s both 1s;
}

@media screen and (max-width: 900px) {
  .ModalCC_boxModal__Hj\\+iU {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes ModalCC_init__KtfK6 {
  0% {
    top: 55%;
    opacity: 0;
  }
  100% {
    top: 50%;
    opacity: 1;
  }
}

@keyframes ModalCC_init2__t6NoA {
  0% {
    transform: translateX(30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes ModalCC_init3__Lyufy {
  0% {
    transform: translateX(-30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/CuentaCorriente/Modal/ModalCC.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,mCAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,8CAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8CAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4CAA6B;AAC/B;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  overflow: scroll;\n  overflow-x: hidden;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 5px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n}\n\n.boxModal .exit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.1;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  display: flex;\n  justify-items: center;\n  align-items: center;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.3rem;\n  margin: 0;\n  margin-left: 5px;\n}\n\n.boxModal .balance p {\n  margin: 0;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 1.5rem;\n  font-weight: 300;\n}\n\n.boxModal .loader {\n  transition: 0.5s;\n  min-height: 40vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .search {\n  animation: init3 0.3s both 1s;\n}\n\n.boxModal .tableContainer {\n  box-shadow: 0 5px 10px -3px rgba(0, 0, 0, 0.211);\n  animation: init2 0.3s both 0.3s;\n  max-height: 100%;\n  border-radius: 5px;\n}\n\n.boxModal .noresult {\n  animation: init3 0.3s both 0.3s;\n  min-height: 40vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.6rem;\n  font-weight: 300;\n}\n\n.boxModal .pagination {\n  animation: init3 0.3s both 1s;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    top: 55%;\n    opacity: 0;\n  }\n  100% {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes init3 {\n  0% {\n    transform: translateX(-30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `ModalCC_boxModal__Hj+iU`,
	"init": `ModalCC_init__KtfK6`,
	"exit": `ModalCC_exit__l0hRt`,
	"exitIcon": `ModalCC_exitIcon__4Z15a`,
	"titleModal": `ModalCC_titleModal__yGma7`,
	"balance": `ModalCC_balance__zNKb2`,
	"loader": `ModalCC_loader__hlQ99`,
	"search": `ModalCC_search__tDNCY`,
	"init3": `ModalCC_init3__Lyufy`,
	"tableContainer": `ModalCC_tableContainer__5DhEW`,
	"init2": `ModalCC_init2__t6NoA`,
	"noresult": `ModalCC_noresult__8oow6`,
	"pagination": `ModalCC_pagination__3fkba`
};
export default ___CSS_LOADER_EXPORT___;
